import { lazy } from "react";

export const Home = lazy(
  () => import(/* webpackChunkName: "page-home" */ "../views/pages/home")
);
export const Users = lazy(
  () => import(/* webpackChunkName: "page-users" */ "../views/pages/users")
);
export const Trainings = lazy(
  () =>
    import(/* webpackChunkName: "page-trainings" */ "../views/pages/trainings")
);
export const Login = lazy(
  () => import(/* webpackChunkName: "page-login" */ "../views/pages/auth/Login")
);
export const Signup = lazy(
  () =>
    import(/* webpackChunkName: "page-signup" */ "../views/pages/auth/Signup")
);
export const ForgotPassword = lazy(
  () =>
    import(
      /* webpackChunkName: "page-forgot-password" */ "../views/pages/auth/forgot"
    )
);
export const Companies = lazy(
  () =>
    import(/* webpackChunkName: "page-companies" */ "../views/pages/companies")
);
export const SampleSource = lazy(
  () =>
    import(
      /* webpackChunkName: "page-sample-source" */ "../views/pages/sampleSource"
    )
);
export const GasAnalysis = lazy(
  () =>
    import(
      /* webpackChunkName: "page-gas-analysis" */ "../views/pages/gasAnalysis"
    )
);
export const DocumentationPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-documentation" */ "../views/pages/documentation"
    )
);
export const PredictionModelsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-prediction-model" */ "../views/pages/PredictionModel"
    )
);
export const OnboardingGuidesPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-onboarding-guides" */ "../views/pages/OnboardingGuides"
    )
);
export const ChangeLogsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-change-logs" */ "../views/pages/changeLogs"
    )
);
export const PrivacyPolicy = lazy(
  () =>
    import(
      /* webpackChunkName: "page-privacy-policy" */ "../views/pages/terms-and-policy/privacyPolicy"
    )
);
export const TermsAndConditions = lazy(
  () =>
    import(
      /* webpackChunkName: "page-terms-and-conditions" */ "../views/pages/terms-and-policy/termsAndConditions"
    )
);
export const ResearchSchedulingPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-rd-schedule" */ "../views/pages/ResearchScheduling/ResearchSchedulingPage"
    )
);
export const AdditiveAlgorithmsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-additive-algorithms" */ "../views/pages/additiveAlgorithms/AdditiveAlgorithmsPage"
    )
);
export const ISCscannerPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-isc-nir-scanner" */ "../views/pages/ISCscanner"
    )
);
export const CropTypes = lazy(
  () =>
    import(
      /* webpackChunkName: "page-crop-types" */ "../views/pages/cropTypes/cropTypesPage"
    )
);
export const DairyRationsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-dairy-ration" */ "../views/pages/dairyRation/DairyRationsPage"
    )
);
export const Settings = lazy(
  () => import(/* webpackChunkName: "page-settings" */ "../views/pages/Settings")
);
export const FileDownload = lazy(
  () =>
    import(
      /* webpackChunkName: "page-file-download" */ "../views/pages/FileDownload"
    )
);
export const FeedersPage = lazy(
  () => import(/* webpackChunkName: "page-feeders" */ "../views/pages/feeders")
);
export const TrainingReportsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-training-reports" */ "../views/pages/trainingReport/TrainingReportsPage"
    )
);
export const TrainingReportDetailPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-training-report-detail" */ "../views/pages/trainingReport/TrainingReportDetailPage"
    )
);
export const FarmManagementPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-farm-management" */ "../views/pages/farmManagement"
    )
);
export const IntakeManagementPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-intake-management" */ "../views/pages/intakeManagement"
    )
);
export const KnowledgePoolPage = lazy(
  () =>
    import(
      /* webpackChunkName: "page-knowledge-pool" */ "../views/pages/knowledgePool"
    )
);
export const AskLogsPage = lazy(
  () =>
    import(/* webpackChunkName: "page-ask-logs" */ "../views/pages/askLogs")
);
export const ApiLogsPage = lazy(
  () =>
    import(/* webpackChunkName: "page-api-logs" */ "../views/pages/apiLogs")
);
